import React from "react";
import { useTranslation } from "react-i18next";
import CompactNumber from "../numbers/CompactNumber";
import GameType from "../../data/GameType";
import shuffleIcon from '../../icons/shuffle.svg';
import trashIcon from '../../icons/trash.svg';

const CompactRow = (props) => {
    const { t } = useTranslation();

    const createNumbers = (numbers, nrType) => {
        var result = [];
        var max = (props.gameType.name === GameType.KENO.name && nrType === "main") ? props.kenoCount : props.gameType[nrType + "Max"];
        for (var i = 0; i < max; i++) {
            result.push(<CompactNumber key={i} number={numbers[i]}></CompactNumber>);
        }
        return result;
    };
    const createButtons = () => {
        return (
            <div className="inlineFlex flexEnd">
                <div className='inlineFlex textCenter flexColumn marginRight1'>
                    <img alt='' className='icon' src={shuffleIcon} onClick={props.onRandom}></img>
                {/*    <span className='smallText'>{t('button.pliksPlaks')}</span> */}
                </div>
                <img alt='' className='icon' src={trashIcon} onClick={props.onDelete}></img>
            </div>
        );
    };
    return (
        <div className="flexGrow1">
            <div className="flexCenter rowLabel">{GameType.labels[props.rowNr]}</div>
            <div className="inlineFlex">{createNumbers(props.row.main, "main")}</div>
            <div className="inlineFlex compactExtra">{createNumbers(props.row.extra, "extra")}</div>
            {!props.compactOnly && createButtons()}
        </div>
    );
};

export default CompactRow;